import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/tool",
    name: "Tool",
    component: () => import("../views/ToolView.vue"),
  },
  {
    path: "/webinar",
    name: "webinar",
    component: () => import("../views/MedaquaWebinarView.vue"),
  },
  {
    // default redirect path to root
    path: "*",
    name: "Default",
    redirect: "/tool",
  },
];

const router = new VueRouter({
  routes
});

export default router;
